import {
    mapState,
    mapActions
} from 'vuex'
import viewName from '../constant'
import {
    Toast
} from 'vant'
import {
    getFirstPage
} from '@/utils/session'
import { LoginComponent } from 'smcommon'
export default {
    name: viewName.login,
    components: {
        Toast,
        LoginComponent: LoginComponent,
    },
    data () {
        return {
            title: '枫车养车',
            imgInfo: {
                setImgCodeVal: '',
                error: false
            },
        }
    },
    computed: {
        ...mapState({
            loginState: ({
                login
            }) => login
        })
    },
    activated () {
    //     // this.refreshImgFn()
        this.setTitle()
    },
    mounted () {
        this.refreshImgFn()
        this.setTitle()
    },
    methods: {
        ...mapActions([
            'setAppClass',
            'getGraphValidateCode',
            'getSendSmsCount',
            'getSmsCode',
            'userLogin'
        ]),
        setTitle () {
            this.setAppClass({
                isAppend: false,
                className: 'bgWhiteColor'
            })
            this.$emit('setHeader', {
                title: '',
                showHeader: false
            })
        },
        apiHander (action, valus) {
            try {
                action && this[action](valus)
            } catch (err) {
                console.error(err)
            }
        },
        // 获取验证码次数接口调用
        async smscount (valus) {
            await this.getSendSmsCount({
                phone: valus.phone,
                type: 'quick_login'
            })
            this.$refs.login.smsCountHandler(this.loginState.smsSendCount)
        },
        // 获取验证码接口调用
        async smscode (valus) {
            const params = {
                phone: valus.phone,
                type: 'quick_login', // type注册：register,找回密码：find_pass，修改密码：set_pass,修改手机：edit_phone，修改提现密码：set_cash，快捷登录：quick_login，绑定微信：bind_wechat
                verify_code: valus.imgCode
            }
            this.getSmsCode(params)
                .then((res) => {
                    this.$refs.login.smsStateHandler('1')
                })
                .catch(_ => {
                    this.$refs.login.smsStateHandler('99')
                })
        },
        // 当次数大于3。获取图形验证码
        async imagecode () {
            this.refreshImgFn()
        },
        // 登录按钮回调
        login (valus) {
            const params = {
                phone: valus.phone,
                captcha: valus.captcha
            }
            this.userLogin(params)
                .then(_ => {
                    this.$refs.login.loginHander('1')
                    if (this.$route.params.type === 'back') {
                        this.$router.go(-1)
                    } else {
                        let last = getFirstPage()
                        console.log('login====', last)
                        if (last && last.fullPath) {
                            this.$router.push({
                                path: last.fullPath
                            })
                        } else {
                            this.$router.push({
                                path: '/'
                            })
                        }
                    }
                }).catch(err => {
                    Toast({
                        message: err.errmsg || '错误',
                        duration: 1500,
                        forbidClick: true,
                        closeOnClick: true
                    })
                    this.$refs.login.loginHander('99')
                })
        },
        // 刷新验证码
        async refreshImgFn () {
            return new Promise(async (resolve) => {
                const data = await this.getGraphValidateCode()
                this.$refs.login.setImageCode(data.img)
                resolve()
            })
        },
    }
}
